import React from 'react';
import styles from './RightPanel.module.scss';
import SuggestionsPanel from '../SuggestionsPanel/SuggestionsPanel';
import ReasoningPanel from '../ReasoningPanel/ReasoningPanel';

import { SuggestedQuestion } from '../../../../../../../../store/dashboard/askAica/actions';
import CrossIcon from '../../../../../../../../assets/Svg/CrossIcon';

interface RightPanelProps {
    mode: 'suggestions' | 'reasoning';
    onModeChange: (mode: 'suggestions' | 'reasoning') => void;
    onSuggestionClick?: (suggestion: SuggestedQuestion) => void;
    onCrossButtonClick?: () => void;
}

const RightPanel: React.FC<RightPanelProps> = ({ mode, onModeChange, onSuggestionClick, onCrossButtonClick }) => {
    return (
        <div className={styles.RightPanel}>
            {/* Toggle Header */}
            <div className={styles.RightPanelHeader}>
                <div className={styles.ToggleButtons}>
                    <button
                        className={`${styles.ToggleButton} ${mode === 'suggestions' ? styles.Active : ''}`}
                        onClick={() => onModeChange('suggestions')}
                    >
                        Suggestions
                    </button>
                    <button
                        className={`${styles.ToggleButton} ${mode === 'reasoning' ? styles.Active : ''}`}
                        onClick={() => onModeChange('reasoning')}
                    >
                        Reasoning
                    </button>
                </div>
                <div className={styles.CrossButton} onClick={onCrossButtonClick}>
                    <CrossIcon colour="#000000" />
                </div>
            </div>

            {/* Panel Content */}
            <div className={styles.RightPanelContent}>
                {mode === 'suggestions' ? <SuggestionsPanel onSuggestionClick={onSuggestionClick} /> : <ReasoningPanel />}
                {/* <SuggestionsPanel onSuggestionClick={onSuggestionClick} /> */}
            </div>
        </div>
    );
};

export default RightPanel;
